import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {isMobile, isStandalone} from '../utils/deviceCheck';
import useAuth from './useAuth';

/**
 * Hook that handles redirecting mobile users to the download page
 * if they're not using the standalone app
 *
 * @param redirectPath - The path to redirect to (defaults to '/download')
 * @returns shouldRender - Boolean indicating if the component should render
 */
export const useMobileDownloadRedirect = (redirectPath: string = '/download'): boolean => {
  const navigate = useNavigate();
  const isProduction = process.env.NODE_ENV === 'production';

  const shouldRedirect = isMobile && !isStandalone() && isProduction;

  useEffect(() => {
    if (shouldRedirect) {
      navigate(redirectPath);
    }
  }, [shouldRedirect, navigate, redirectPath]);

  // Return false if should redirect (don't render component)
  // Return true if should not redirect (render component normally)
  return !shouldRedirect;
};

export default useMobileDownloadRedirect;
